import consumer, { createConsumerWithToken } from "./consumer"

// This file is automatically loaded by the `channels/index.js` file
// Add it to the imports in that file if needed

// Create a subscription to the StatefulJobChannel
// This is used to receive real-time updates about stateful jobs
document.addEventListener('DOMContentLoaded', () => {
  // This function can be called from any page that needs to subscribe to a stateful job
  window.subscribeToStatefulJob = function(jobId, token, callbacks = {}) {
    console.log(`Subscribing to StatefulJob with ID: ${jobId}`);

    // Use the token to create a consumer if provided, otherwise use the default consumer
    const consumerToUse = token ? createConsumerWithToken(token) : consumer;

    // Create a subscription for this job ID
    const subscription = consumerToUse.subscriptions.create(
      { 
        channel: "StatefulJobChannel", 
        id: jobId 
      }, 
      {
        connected() {
          // Called when the subscription is ready for use on the server
          console.log(`Connected to StatefulJobChannel for job ID: ${jobId}`);
          if (callbacks.connected) callbacks.connected();
        },

        disconnected() {
          // Called when the subscription has been terminated by the server
          console.log(`Disconnected from StatefulJobChannel for job ID: ${jobId}`);
          if (callbacks.disconnected) callbacks.disconnected();
        },

        rejected() {
          // Called when the subscription is rejected by the server
          console.error(`Subscription to StatefulJobChannel for job ID: ${jobId} was rejected`);
          if (callbacks.rejected) callbacks.rejected();
        },

        received(data) {
          // Called when there's incoming data on the websocket for this channel
          console.log(`Received data from StatefulJobChannel for job ID: ${jobId}`, data);
          if (callbacks.received) callbacks.received(data);
        }
      }
    );

    return subscription;
  };
});
